<!-- components/AgendaTable.vue -->
<template>
  <table v-if="hasItems">
    <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td class="date">
          <!-- {{ item.date }} -->
          <Abbreviate :label="item.date" />
        </td>
        <td>
          <span class="event-name">
            {{ item.event }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import {computed} from "vue";
import Abbreviate from "./Abbreviate.vue";

const props = defineProps(["items"]);

const hasItems = computed(() => {
  if (!props.items) return false;
  if (!Array.isArray(props.items)) return false;
  if (props.items.length === 0) return false;
  return true;
});
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.2);
}

td {
  padding: var(--space-xx-small, 0.25rem) var(--space-x-small, 0.5rem);
  vertical-align: top;
}

.date {
  white-space: nowrap;
  font-weight: 600;
}

.event-name {
  display: inline-block;
}
</style>
